export const GETTING_ENGAGEMENT_DEFAULT_ANSWER_ORDER =
  "GETTING_ENGAGEMENT_DEFAULT_ANSWER_ORDER";
export const CANCEL_GETTING_DEFAULT_ANSWER_ORDER =
  "CANCEL_GETTING_DEFAULT_ANSWER_ORDER";
export const GOT_ENGAGEMENT_DEFAULT_ANSWER_ORDER =
  "GOT_ENGAGEMENT_DEFAULT_ANSWER_ORDER";
